module.exports = __webpack_public_path__ + "img/haowu@2x (2).c59d42d3.png";